var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 803"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 7.21053C11 7.08421 10.726 7 10.4521 7H7.54795C7.21918 7 7 7.10526 7 7.21053V8.78947C7 8.91579 7.27397 9 7.54795 9H10.4521C10.7808 9 11 8.89474 11 8.78947V7.21053Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 7.21053C16 7.08421 15.726 7 15.4521 7H12.5479C12.2192 7 12 7.10526 12 7.21053V8.78947C12 8.91579 12.274 9 12.5479 9H15.4521C15.7808 9 16 8.89474 16 8.78947V7.21053Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11 11.2105C11 11.0842 10.726 11 10.4521 11H7.54795C7.21918 11 7 11.1053 7 11.2105V12.7895C7 12.9158 7.27397 13 7.54795 13H10.4521C10.7808 13 11 12.8947 11 12.7895V11.2105Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16 11.2105C16 11.0842 15.726 11 15.4521 11H12.5479C12.2192 11 12 11.1053 12 11.2105V12.7895C12 12.9158 12.274 13 12.5479 13H15.4521C15.7808 13 16 12.8947 16 12.7895V11.2105Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11 15.2105C11 15.0842 10.726 15 10.4521 15H7.54795C7.21918 15 7 15.1053 7 15.2105V16.7895C7 16.9158 7.27397 17 7.54795 17H10.4521C10.7808 17 11 16.8947 11 16.7895V15.2105Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16 15.2105C16 15.0842 15.726 15 15.4521 15H12.5479C12.2192 15 12 15.1053 12 15.2105V16.7895C12 16.9158 12.274 17 12.5479 17H15.4521C15.7808 17 16 16.8947 16 16.7895V15.2105Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10.4521 19H7.54795C7.21918 19 7 19.1053 7 19.2105V20.7895C7 20.9158 7.27397 21 7.54795 21H10.4521C10.7808 21 11 20.8947 11 20.7895V19.2105C11 19.1053 10.7808 19 10.4521 19Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M22.3956 19.2926H17.0222C15.5966 19.2926 14.4178 20.4942 14.4178 21.9688V24.0169H5.56266C5.2611 24.0169 5.01436 23.7438 5.01436 23.4161V5.61118C5.01436 5.28348 5.2611 5.0104 5.56266 5.0104H18.6397C18.9413 5.0104 19.188 5.28348 19.188 5.61118V13.1209C17.8172 13.3394 16.7755 14.541 16.7755 15.961C16.7755 17.5449 18.064 18.8557 19.6815 18.8557C21.299 18.8557 22.5875 17.5722 22.5875 15.961C22.5875 14.541 21.5731 13.3667 20.2298 13.1209V5.61118C20.2298 4.71001 19.517 4 18.6671 4H5.56266C4.68538 4 4 4.73732 4 5.61118V23.3888C4 24.29 4.71279 25 5.56266 25H14.4178H25V21.9688C25 20.4942 23.8211 19.2926 22.3956 19.2926Z",
    fill: "#898989"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManIcon);
export default __webpack_public_path__ + "static/media/manIcon.ba3f9e88c0e1d65b69bf75f0e097cdb2.svg";
export { ForwardRef as ReactComponent };